import { render, staticRenderFns } from "./layout-souvenir.vue?vue&type=template&id=257fb76f&scoped=true&"
import script from "./layout-souvenir.js?vue&type=script&lang=js&"
export * from "./layout-souvenir.js?vue&type=script&lang=js&"
import style0 from "./layout-souvenir.scss?vue&type=style&index=0&id=257fb76f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257fb76f",
  null
  
)

export default component.exports